type Primitive = string | number;

class ArraysUtils {
  /**
   * Add the value to the end of the array if it does not exists, or remove it if exists.
   * Creates a new array, the array is not modified.
   * @param value Value to add or remove.
   * @param array Array of values.
   */
  static addOrRemove = (value: any, array: Array<any>) => {
    if (array.some((item) => item === value)) {
      // Remove it
      return array.filter((item) => item !== value);
    }
    return array.concat([value]);
  };

  static addOrRemoveObjectByKey = (value: any, array: Array<any>, key: string) => {
    let editedArray = [...array];
    if (value && key && key in value) {
      const isInArray = editedArray.length
        ? editedArray.find((item) => item[key] === value[key])
        : false;
      editedArray = isInArray
        ? editedArray.filter((item) => item[key] !== value[key])
        : editedArray.concat([value]);
    }
    return editedArray;
  };

  static equals = (left: Array<Primitive>, right: Array<Primitive>) => {
    if (left.length !== right.length) {
      return false;
    }
    return left.filter((item) => right.indexOf(item) === -1).length === 0;
  };
}

export default ArraysUtils;
